

































import Vue from 'vue';
import { Model, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import StarRating from 'vue-star-rating';

Vue.component('star-rating', StarRating);

@Component({
	componentId: 'C026',
	components: {
		StarRating
	},
	inheritAttrs: false
})
export default class RatingInput extends Vue {
	@Prop(String)
	protected readonly id!: string;

	@Prop({ type: String, default: '' })
	protected readonly name!: string;

	@Prop(String)
	protected readonly label?: string;

	@Prop(Number)
	protected readonly numberOfStars?: string;

	@Model('input', { type: Number, default: 0 })
	protected value!: number;

	protected localValue: number = this.value;

	protected labelLong: boolean = false;

	protected mounted(): void {
		if (this.label) {
			const label = this.$refs.fieldLabel as HTMLElement;
			if (label) {
				const isMultiLine = label.scrollHeight > label.clientHeight;
				if (isMultiLine) {
					this.labelLong = true;
				}
			}
		}
	}

	protected get isRequired(): boolean {
		return this.$attrs.required !== undefined && this.$attrs.required !== 'false';
	}

	protected get inputId(): string {
		return `${this.id}-input`;
	}

	protected updateRating(rating: number): void {
		// console.log(`The current rating is: ${rating}`);
		this.localValue = rating;
		this.$emit('input', this.localValue);
	}
}
